import {
  Button,
  Image,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { getWebUrl } from "@ui/../config/src";

export interface ThankYouModalProps {
  isOpen: boolean;
}

export const ThankYouModal = ({ isOpen }: ThankYouModalProps) => {
  const { onClose } = useDisclosure();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={0}
        w="90%"
        minW={{
          md: "700px",
        }}
      >
        <ModalHeader display="flex" justifyContent="end">
          <Link
            href={getWebUrl()}
            fontSize={{
              base: 13,
              md: 15,
            }}
            fontWeight="normal"
            textDecoration="underline"
          >
            Back to site
          </Link>
        </ModalHeader>
        <ModalBody textAlign="center" px={10} pb={10} w="80%" mx="auto">
          <Image
            src="https://media.graphassets.com/gZgR5gFR3Wk9YOWtPgU5"
            mx="auto"
            pb={5}
          />
          <Text
            fontSize={{
              base: 24,
              md: 30,
            }}
            fontWeight="bold"
            pb={{
              base: 1,
              md: 3,
            }}
          >
            Thank You
          </Text>
          <Text
            fontSize={{
              base: 13,
              md: 16,
            }}
          >
            Your submission has been received. We will be in touch and contact
            you soon!
          </Text>
          <Button mt={6} colorScheme="blue">
            <Link
              href={getWebUrl()}
              fontWeight="bold"
              textTransform="uppercase"
            >
              Back to site
            </Link>
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
